export const LOADING = "LOADING"
export const RESULT = "RESULT"

export const LIST = "LINK_LIST"
export const LIST_VM = "LINK_LIST_VM"
export const INIT_CREATE = "LINK_INIT_CREATE"
export const CREATE = "LINK_CREATE"
export const READ = "LINK_INFO"
export const UPDATE = "LINK_UPDATE"
export const STOCK_UPDATE = "STOCK_LINK_UPDATE"
export const DELETE = "LINK_DELETE"
